import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private storage: Map<string, string> = new Map<string, string>();

  /**
   * Sets an item in the service's internal storage
   * @param key The key to store the value under
   * @param value The value to store
   */
  setItem(key: string, value: string): void {
    this.storage.set(key, value);
  }

  /**
   * Gets an item from the service's internal storage
   * @param key The key to retrieve
   * @returns The value or null if not found
   */
  getItem(key: string): string | null {
    if (!this.storage.has(key)) {
      return null;
    }

    return this.storage.get(key) || null;
  }

  /**
   * Removes an item from the service's internal storage
   * @param key The key to remove
   */
  removeItem(key: string): void {
    this.storage.delete(key);
  }

  /**
   * Clears all items from the service's internal storage
   */
  clear(): void {
    this.storage.clear();
  }
}
